import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { ProductDataForm, ProductFilters } from '../../../../app/models/Product';
import ProductSwitchChange from '../ProductSwitchChange';
import {ServiceDataForm} from "../../../../app/models/Service";
import {formatMoney} from "../../../../utils/utils";
import ProductFilter from './ProductFilter';

interface Props {
    products: ProductDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: ProductFilters;
    setFilter: (filter: ProductFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const ProductDataTable = ({
    products,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: ProductDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>
            )
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: ProductDataForm, index: any, column: any) => (
                <span className="">{row.name}</span>
            )
        },
        {
            name: 'Sector',
            selector: (row: any) => row.sector,
            sortable: true,
            sortField: 'sector',
            cell: (row: ServiceDataForm, index: any, column: any) => (
                <span className="">{row.sector}</span>
            )
        },
        {
            name: 'Categoría',
            selector: (row: any) => row.item_category,
            sortable: true,
            sortField: 'item_category',
            cell: (row: ServiceDataForm, index: any, column: any) => (
                <span className="">{row.item_category}</span>
            )
        },
                {
            name: 'Precio',
            selector: (row: any) => row.price,
            sortable: true,
            sortField: 'price',
            cell: (row: ServiceDataForm, index: any, column: any) => (
                <span className="">{formatMoney(row.price ?? 0)} {row.currency_price}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: ProductDataForm, index: any, column: any) => (
                <ProductSwitchChange
                    checkValue={row.is_active ?? true}
                    productId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: ProductDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <ProductFilter 
                        filter={filter} 
                        setFilter={setFilter} 
                    />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={products}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default ProductDataTable;
